<template>
    <div style="width: 100%; color: darkgray; align-items: center" class="d-flex flex-row mt-5">
        <i class="fa fa-sticky-note display-3 mr-3 ml-3"></i>
        <span class="mt-2">{{language.lang('This list is empty')}}</span>
    </div>
</template>
<script>
    import oracle from "@/utils/oracle";
    import language from "@/utils/language";

    export default {
        data: () => ({
            oracle: oracle,
            language: language,
            isEN: oracle.isEN(),
        })
    }
</script>
<style>

</style>